import { useEffect, useRef, DependencyList } from "react";

export const useOutSideClick = <TElement extends HTMLElement = HTMLDivElement>(
    handler: (e: Event) => void,
    deps: DependencyList,
    outsideException?: string
) => {
    const ref = useRef<TElement>(null);

    useEffect(() => {
        const listener = (event: Event) => {
            if (!ref.current?.contains(event.target as HTMLElement)) {
                (
                    (outsideException && !Array.from(document.querySelectorAll(outsideException)).some(item => item.contains(event.target as HTMLElement)))
                    || !outsideException
                ) && handler(event);
            }
        };

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, deps ? [ref, ...deps] : [ref, handler]);

    return ref;
}